// source: acompanha/subscription_billing/v1/subscription_billing.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.BillingExemption', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.SubscriptionCharge', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.SubscriptionChargeSections', null, global);
goog.exportSymbol('proto.acompanha.subscription_billing.v1.SubscriptionPayment', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.BillingExemption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.BillingExemption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.BillingExemption.displayName = 'proto.acompanha.subscription_billing.v1.BillingExemption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.displayName = 'proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.displayName = 'proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.displayName = 'proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.displayName = 'proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.displayName = 'proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.displayName = 'proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.SubscriptionCharge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.SubscriptionCharge.displayName = 'proto.acompanha.subscription_billing.v1.SubscriptionCharge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.SubscriptionChargeSections, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.displayName = 'proto.acompanha.subscription_billing.v1.SubscriptionChargeSections';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.displayName = 'proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.displayName = 'proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.displayName = 'proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.displayName = 'proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.displayName = 'proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.displayName = 'proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.SubscriptionPayment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.SubscriptionPayment.displayName = 'proto.acompanha.subscription_billing.v1.SubscriptionPayment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.displayName = 'proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.displayName = 'proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.displayName = 'proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.displayName = 'proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.displayName = 'proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.displayName = 'proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.displayName = 'proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.displayName = 'proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.displayName = 'proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.displayName = 'proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.displayName = 'proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.BillingExemption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.BillingExemption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.BillingExemption.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
userUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
reason: jspb.Message.getFieldWithDefault(msg, 5, ""),
exemptUntil: (f = msg.getExemptUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
indefinite: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
createdBy: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.BillingExemption;
  return proto.acompanha.subscription_billing.v1.BillingExemption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.BillingExemption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExemptUntil(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIndefinite(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.BillingExemption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.BillingExemption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.BillingExemption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExemptUntil();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getIndefinite();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_uuid = 2;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_email = 4;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string reason = 5;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp exempt_until = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getExemptUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
*/
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setExemptUntil = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.clearExemptUntil = function() {
  return this.setExemptUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.hasExemptUntil = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool indefinite = 7;
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getIndefinite = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setIndefinite = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
*/
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
*/
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string created_by = 10;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption} returns this
 */
proto.acompanha.subscription_billing.v1.BillingExemption.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest;
  return proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.acompanha.subscription_billing.v1.BillingExemption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse;
  return proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.BillingExemption;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.BillingExemption.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.BillingExemption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BillingExemption data = 1;
 * @return {!Array<!proto.acompanha.subscription_billing.v1.BillingExemption>}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_billing.v1.BillingExemption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_billing.v1.BillingExemption, 1));
};


/**
 * @param {!Array<!proto.acompanha.subscription_billing.v1.BillingExemption>} value
 * @return {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse} returns this
*/
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.BillingExemption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_billing.v1.BillingExemption}
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.subscription_billing.v1.BillingExemption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse} returns this
 */
proto.acompanha.subscription_billing.v1.ListBillingExemptionsResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
exemptUntil: (f = msg.getExemptUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
reason: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest;
  return proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExemptUntil(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getExemptUntil();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} returns this
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp exempt_until = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.getExemptUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} returns this
*/
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.setExemptUntil = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} returns this
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.clearExemptUntil = function() {
  return this.setExemptUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.hasExemptUntil = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string reason = 3;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest} returns this
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.subscription_billing.v1.BillingExemption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse;
  return proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.BillingExemption;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.BillingExemption.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.BillingExemption.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingExemption data = 1;
 * @return {?proto.acompanha.subscription_billing.v1.BillingExemption}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.subscription_billing.v1.BillingExemption} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_billing.v1.BillingExemption, 1));
};


/**
 * @param {?proto.acompanha.subscription_billing.v1.BillingExemption|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse} returns this
*/
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse} returns this
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.CreateBillingExemptionResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest;
  return proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest} returns this
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.subscription_billing.v1.BillingExemption.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse;
  return proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.BillingExemption;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.BillingExemption.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.BillingExemption.serializeBinaryToWriter
    );
  }
};


/**
 * optional BillingExemption data = 1;
 * @return {?proto.acompanha.subscription_billing.v1.BillingExemption}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.subscription_billing.v1.BillingExemption} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_billing.v1.BillingExemption, 1));
};


/**
 * @param {?proto.acompanha.subscription_billing.v1.BillingExemption|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse} returns this
*/
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse} returns this
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.RevokeBillingExemptionResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject = function(includeInstance, msg) {
  var f, obj = {
userUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
userName: jspb.Message.getFieldWithDefault(msg, 2, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 3, ""),
chargeType: jspb.Message.getFieldWithDefault(msg, 4, ""),
currentPlanName: jspb.Message.getFieldWithDefault(msg, 5, ""),
billablePlanName: jspb.Message.getFieldWithDefault(msg, 6, ""),
billablePlanPriceCents: jspb.Message.getFieldWithDefault(msg, 7, 0),
pendingPlanName: jspb.Message.getFieldWithDefault(msg, 8, ""),
pendingPlanPriceCents: jspb.Message.getFieldWithDefault(msg, 9, 0),
planMigrationPending: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
planDowngradePending: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
renewalGroup: jspb.Message.getFieldWithDefault(msg, 12, ""),
boletoAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
pixAvailable: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
boletoUrl: jspb.Message.getFieldWithDefault(msg, 15, ""),
pixQrUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
planRenewalDate: jspb.Message.getFieldWithDefault(msg, 17, ""),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.SubscriptionCharge;
  return proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrentPlanName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBillablePlanName(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBillablePlanPriceCents(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPendingPlanName(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPendingPlanPriceCents(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlanMigrationPending(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPlanDowngradePending(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRenewalGroup(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setBoletoAvailable(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPixAvailable(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoletoUrl(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setPixQrUrl(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanRenewalDate(value);
      break;
    case 18:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChargeType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrentPlanName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBillablePlanName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBillablePlanPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getPendingPlanName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPendingPlanPriceCents();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getPlanMigrationPending();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getPlanDowngradePending();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getRenewalGroup();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getBoletoAvailable();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getPixAvailable();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getBoletoUrl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getPixQrUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getPlanRenewalDate();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string user_uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_name = 2;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_email = 3;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string charge_type = 4;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getChargeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setChargeType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string current_plan_name = 5;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getCurrentPlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setCurrentPlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string billable_plan_name = 6;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getBillablePlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setBillablePlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 billable_plan_price_cents = 7;
 * @return {number}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getBillablePlanPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setBillablePlanPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string pending_plan_name = 8;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getPendingPlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setPendingPlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int64 pending_plan_price_cents = 9;
 * @return {number}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getPendingPlanPriceCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setPendingPlanPriceCents = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional bool plan_migration_pending = 10;
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getPlanMigrationPending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setPlanMigrationPending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool plan_downgrade_pending = 11;
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getPlanDowngradePending = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setPlanDowngradePending = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string renewal_group = 12;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getRenewalGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setRenewalGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional bool boleto_available = 13;
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getBoletoAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setBoletoAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * optional bool pix_available = 14;
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getPixAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setPixAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional string boleto_url = 15;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getBoletoUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setBoletoUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string pix_qr_url = 16;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getPixQrUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setPixQrUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string plan_renewal_date = 17;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getPlanRenewalDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setPlanRenewalDate = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional google.protobuf.Timestamp updated_at = 18;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 18));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
*/
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.SubscriptionCharge.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 18) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.repeatedFields_ = [1,2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.toObject = function(includeInstance, msg) {
  var f, obj = {
migrationsList: jspb.Message.toObjectList(msg.getMigrationsList(),
    proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject, includeInstance),
todayList: jspb.Message.toObjectList(msg.getTodayList(),
    proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject, includeInstance),
tomorrowList: jspb.Message.toObjectList(msg.getTomorrowList(),
    proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject, includeInstance),
othersList: jspb.Message.toObjectList(msg.getOthersList(),
    proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.SubscriptionChargeSections;
  return proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionCharge;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader);
      msg.addMigrations(value);
      break;
    case 2:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionCharge;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader);
      msg.addToday(value);
      break;
    case 3:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionCharge;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader);
      msg.addTomorrow(value);
      break;
    case 4:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionCharge;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader);
      msg.addOthers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMigrationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter
    );
  }
  f = message.getTodayList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter
    );
  }
  f = message.getTomorrowList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter
    );
  }
  f = message.getOthersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionCharge migrations = 1;
 * @return {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.getMigrationsList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionCharge, 1));
};


/**
 * @param {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} returns this
*/
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.setMigrationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionCharge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.addMigrations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.subscription_billing.v1.SubscriptionCharge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.clearMigrationsList = function() {
  return this.setMigrationsList([]);
};


/**
 * repeated SubscriptionCharge today = 2;
 * @return {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.getTodayList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionCharge, 2));
};


/**
 * @param {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} returns this
*/
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.setTodayList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionCharge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.addToday = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.acompanha.subscription_billing.v1.SubscriptionCharge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.clearTodayList = function() {
  return this.setTodayList([]);
};


/**
 * repeated SubscriptionCharge tomorrow = 3;
 * @return {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.getTomorrowList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionCharge, 3));
};


/**
 * @param {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} returns this
*/
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.setTomorrowList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionCharge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.addTomorrow = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.acompanha.subscription_billing.v1.SubscriptionCharge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.clearTomorrowList = function() {
  return this.setTomorrowList([]);
};


/**
 * repeated SubscriptionCharge others = 4;
 * @return {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.getOthersList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionCharge, 4));
};


/**
 * @param {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} returns this
*/
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.setOthersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionCharge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.addOthers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.acompanha.subscription_billing.v1.SubscriptionCharge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.prototype.clearOthersList = function() {
  return this.setOthersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest;
  return proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
chargesList: jspb.Message.toObjectList(msg.getChargesList(),
    proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject, includeInstance),
sections: (f = msg.getSections()) && proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse;
  return proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionCharge;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader);
      msg.addCharges(value);
      break;
    case 2:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionChargeSections;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.deserializeBinaryFromReader);
      msg.setSections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChargesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter
    );
  }
  f = message.getSections();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionChargeSections.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionCharge charges = 1;
 * @return {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.getChargesList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionCharge, 1));
};


/**
 * @param {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionCharge>} value
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse} returns this
*/
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.setChargesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionCharge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.addCharges = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.subscription_billing.v1.SubscriptionCharge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse} returns this
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.clearChargesList = function() {
  return this.setChargesList([]);
};


/**
 * optional SubscriptionChargeSections sections = 2;
 * @return {?proto.acompanha.subscription_billing.v1.SubscriptionChargeSections}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.getSections = function() {
  return /** @type{?proto.acompanha.subscription_billing.v1.SubscriptionChargeSections} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionChargeSections, 2));
};


/**
 * @param {?proto.acompanha.subscription_billing.v1.SubscriptionChargeSections|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse} returns this
*/
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.setSections = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse} returns this
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.clearSections = function() {
  return this.setSections(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionChargesResponse.prototype.hasSections = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userUuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest;
  return proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string user_uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest} returns this
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeRequest.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
charge: (f = msg.getCharge()) && proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse;
  return proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionCharge;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader);
      msg.setCharge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCharge();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionCharge charge = 1;
 * @return {?proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.prototype.getCharge = function() {
  return /** @type{?proto.acompanha.subscription_billing.v1.SubscriptionCharge} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionCharge, 1));
};


/**
 * @param {?proto.acompanha.subscription_billing.v1.SubscriptionCharge|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse} returns this
*/
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.prototype.setCharge = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse} returns this
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.prototype.clearCharge = function() {
  return this.setCharge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionChargeResponse.prototype.hasCharge = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
userUuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
boleto: jspb.Message.getFieldWithDefault(msg, 2, ""),
pixQr: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest;
  return proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoleto(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPixQr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoleto();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPixQr();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string user_uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} returns this
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string boleto = 2;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.prototype.getBoleto = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} returns this
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.prototype.setBoleto = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string pix_qr = 3;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.prototype.getPixQr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest} returns this
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeRequest.prototype.setPixQr = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
charge: (f = msg.getCharge()) && proto.acompanha.subscription_billing.v1.SubscriptionCharge.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse;
  return proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionCharge;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionCharge.deserializeBinaryFromReader);
      msg.setCharge(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCharge();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionCharge.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionCharge charge = 1;
 * @return {?proto.acompanha.subscription_billing.v1.SubscriptionCharge}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.prototype.getCharge = function() {
  return /** @type{?proto.acompanha.subscription_billing.v1.SubscriptionCharge} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionCharge, 1));
};


/**
 * @param {?proto.acompanha.subscription_billing.v1.SubscriptionCharge|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse} returns this
*/
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.prototype.setCharge = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse} returns this
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.prototype.clearCharge = function() {
  return this.setCharge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.AttachSubscriptionChargeResponse.prototype.hasCharge = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.SubscriptionPayment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
userUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
subscriptionPlanUuid: jspb.Message.getFieldWithDefault(msg, 5, ""),
subscriptionPlanName: jspb.Message.getFieldWithDefault(msg, 6, ""),
amountCents: jspb.Message.getFieldWithDefault(msg, 7, 0),
status: jspb.Message.getFieldWithDefault(msg, 8, ""),
rejectionReason: jspb.Message.getFieldWithDefault(msg, 9, ""),
reviewedBy: jspb.Message.getFieldWithDefault(msg, 10, ""),
receiptUrl: jspb.Message.getFieldWithDefault(msg, 11, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
reviewedAt: (f = msg.getReviewedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.SubscriptionPayment;
  return proto.acompanha.subscription_billing.v1.SubscriptionPayment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionPlanUuid(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionPlanName(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAmountCents(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRejectionReason(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setReviewedBy(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptUrl(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setReviewedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.SubscriptionPayment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubscriptionPlanUuid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSubscriptionPlanName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRejectionReason();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getReviewedBy();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getReceiptUrl();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getReviewedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_uuid = 2;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_email = 4;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subscription_plan_uuid = 5;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getSubscriptionPlanUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setSubscriptionPlanUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string subscription_plan_name = 6;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getSubscriptionPlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setSubscriptionPlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 amount_cents = 7;
 * @return {number}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string status = 8;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string rejection_reason = 9;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getRejectionReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setRejectionReason = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string reviewed_by = 10;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getReviewedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setReviewedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string receipt_url = 11;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getReceiptUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setReceiptUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
*/
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
*/
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Timestamp reviewed_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.getReviewedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
*/
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.setReviewedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment} returns this
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.clearReviewedAt = function() {
  return this.setReviewedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.SubscriptionPayment.prototype.hasReviewedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest;
  return proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
paymentsList: jspb.Message.toObjectList(msg.getPaymentsList(),
    proto.acompanha.subscription_billing.v1.SubscriptionPayment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse;
  return proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionPayment;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionPayment.deserializeBinaryFromReader);
      msg.addPayments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPaymentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionPayment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SubscriptionPayment payments = 1;
 * @return {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionPayment>}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.prototype.getPaymentsList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_billing.v1.SubscriptionPayment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionPayment, 1));
};


/**
 * @param {!Array<!proto.acompanha.subscription_billing.v1.SubscriptionPayment>} value
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse} returns this
*/
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.prototype.setPaymentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.SubscriptionPayment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_billing.v1.SubscriptionPayment}
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.prototype.addPayments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.subscription_billing.v1.SubscriptionPayment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse} returns this
 */
proto.acompanha.subscription_billing.v1.ListSubscriptionPaymentsResponse.prototype.clearPaymentsList = function() {
  return this.setPaymentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest;
  return proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest} returns this
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
payment: (f = msg.getPayment()) && proto.acompanha.subscription_billing.v1.SubscriptionPayment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse;
  return proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionPayment;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionPayment.deserializeBinaryFromReader);
      msg.setPayment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPayment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionPayment.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionPayment payment = 1;
 * @return {?proto.acompanha.subscription_billing.v1.SubscriptionPayment}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.prototype.getPayment = function() {
  return /** @type{?proto.acompanha.subscription_billing.v1.SubscriptionPayment} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionPayment, 1));
};


/**
 * @param {?proto.acompanha.subscription_billing.v1.SubscriptionPayment|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse} returns this
*/
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.prototype.setPayment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse} returns this
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.prototype.clearPayment = function() {
  return this.setPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.GetSubscriptionPaymentResponse.prototype.hasPayment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest;
  return proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest} returns this
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
payment: (f = msg.getPayment()) && proto.acompanha.subscription_billing.v1.SubscriptionPayment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse;
  return proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionPayment;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionPayment.deserializeBinaryFromReader);
      msg.setPayment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPayment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionPayment.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionPayment payment = 1;
 * @return {?proto.acompanha.subscription_billing.v1.SubscriptionPayment}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.prototype.getPayment = function() {
  return /** @type{?proto.acompanha.subscription_billing.v1.SubscriptionPayment} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionPayment, 1));
};


/**
 * @param {?proto.acompanha.subscription_billing.v1.SubscriptionPayment|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse} returns this
*/
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.prototype.setPayment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse} returns this
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.prototype.clearPayment = function() {
  return this.setPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.ApproveSubscriptionPaymentResponse.prototype.hasPayment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
reason: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest;
  return proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setReason(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getReason();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest} returns this
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string reason = 2;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.prototype.getReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest} returns this
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentRequest.prototype.setReason = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
payment: (f = msg.getPayment()) && proto.acompanha.subscription_billing.v1.SubscriptionPayment.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse;
  return proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.SubscriptionPayment;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.SubscriptionPayment.deserializeBinaryFromReader);
      msg.setPayment(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPayment();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.SubscriptionPayment.serializeBinaryToWriter
    );
  }
};


/**
 * optional SubscriptionPayment payment = 1;
 * @return {?proto.acompanha.subscription_billing.v1.SubscriptionPayment}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.prototype.getPayment = function() {
  return /** @type{?proto.acompanha.subscription_billing.v1.SubscriptionPayment} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.subscription_billing.v1.SubscriptionPayment, 1));
};


/**
 * @param {?proto.acompanha.subscription_billing.v1.SubscriptionPayment|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse} returns this
*/
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.prototype.setPayment = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse} returns this
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.prototype.clearPayment = function() {
  return this.setPayment(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.RejectSubscriptionPaymentResponse.prototype.hasPayment = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
userUuid: jspb.Message.getFieldWithDefault(msg, 2, ""),
userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
userEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
planName: jspb.Message.getFieldWithDefault(msg, 5, ""),
mpPreapprovalId: jspb.Message.getFieldWithDefault(msg, 6, ""),
status: jspb.Message.getFieldWithDefault(msg, 7, ""),
trialActive: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
graceUntil: (f = msg.getGraceUntil()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
nextPaymentDate: (f = msg.getNextPaymentDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
lastPaymentStatus: jspb.Message.getFieldWithDefault(msg, 11, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow;
  return proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserUuid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMpPreapprovalId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTrialActive(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setGraceUntil(value);
      break;
    case 10:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setNextPaymentDate(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastPaymentStatus(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserUuid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUserEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPlanName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMpPreapprovalId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getTrialActive();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getGraceUntil();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getNextPaymentDate();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastPaymentStatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_uuid = 2;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getUserUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setUserUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string user_email = 4;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getUserEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setUserEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string plan_name = 5;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getPlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setPlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string mp_preapproval_id = 6;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getMpPreapprovalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setMpPreapprovalId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool trial_active = 8;
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getTrialActive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setTrialActive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp grace_until = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getGraceUntil = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
*/
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setGraceUntil = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.clearGraceUntil = function() {
  return this.setGraceUntil(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.hasGraceUntil = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional google.protobuf.Timestamp next_payment_date = 10;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getNextPaymentDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 10));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
*/
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setNextPaymentDate = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.clearNextPaymentDate = function() {
  return this.setNextPaymentDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.hasNextPaymentDate = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string last_payment_status = 11;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getLastPaymentStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setLastPaymentStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
*/
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
*/
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow} returns this
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
q: jspb.Message.getFieldWithDefault(msg, 1, ""),
status: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest;
  return proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setQ(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getQ();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string q = 1;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.prototype.getQ = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest} returns this
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.prototype.setQ = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest} returns this
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse;
  return proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow;
      reader.readMessage(value,proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MPSubscriptionAdminRow data = 1;
 * @return {!Array<!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow>}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow, 1));
};


/**
 * @param {!Array<!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow>} value
 * @return {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse} returns this
*/
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow}
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.subscription_billing.v1.MPSubscriptionAdminRow, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse} returns this
 */
proto.acompanha.subscription_billing.v1.ListMPSubscriptionsResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


goog.object.extend(exports, proto.acompanha.subscription_billing.v1);
